import React from "react";

interface ImagePictureAddPlusIconProps extends React.SVGProps<SVGSVGElement> {
  size?: string;
}

export const ImagePictureAddPlusIcon: React.FC<
  ImagePictureAddPlusIconProps
> = ({ size, color, ...svgProps }) => {
  return (
    <svg
      width={size ?? "20px"}
      height={size ?? "21px"}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M2.5 13.8334C6.94444 10.5 13.0556 10.5 17.5 13.8334"
        stroke={color ?? "#667085"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.51949 7.01986L6.51986 7.01949C6.60111 6.93845 6.73265 6.93857 6.81375 7.01977C6.89484 7.10096 6.8948 7.23251 6.81366 7.31366C6.73251 7.3948 6.60096 7.39484 6.51977 7.31375C6.43857 7.23265 6.43845 7.10111 6.51949 7.01986"
        stroke={color ?? "#667085"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4167 6.74996V3.41663"
        stroke={color ?? "#667085"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 5.08329H17.0833"
        stroke={color ?? "#667085"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8333 3H6.66667C4.36548 3 2.5 4.86548 2.5 7.16667V13.8333C2.5 16.1345 4.36548 18 6.66667 18H13.3333C15.6345 18 17.5 16.1345 17.5 13.8333V9.66667"
        stroke={color ?? "#667085"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
